import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const SubscriptionProfileGuard = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("user3ayin"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      if (!userData?.token) {
        toast.error(t("please_log_in_to_continue"));
        navigate("/login");
        return;
      }

      try {
        const res = await axios.get(
          "https://app.xn--mgb9a0bp.com/api/profileData",
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
              Lang: i18n.language,
            },
          }
        );

        const user = res.data?.data?.user;

        if (!user?.is_profile_completed) {
          toast.error(
            i18n.language === "ar"
              ? "يرجى إكمال الملف الشخصي أولاً"
              : "Please complete your profile first"
          );
          navigate("/user_profile");
          return;
        }

        if (!user?.subscription) {
          toast.info(
            i18n.language === "ar"
              ? "يجب الاشتراك أولاً في باقة قبل الإضافة"
              : "You must subscribe first before adding"
          );
          navigate("/packages");
          return;
        }

        if (user?.is_active === false) {
          toast.warning(
            i18n.language === "ar"
              ? "حسابك قيد المراجعة"
              : "Your account is pending"
          );
          navigate("/");
          return;
        }

        setLoading(false);

      } catch (err) {
        console.error(err);
        navigate("/login");
      }
    };

    check();
  }, [i18n.language]);

  if (loading) return null;

  return <Outlet />;
};

export default SubscriptionProfileGuard;